const ProductDetailDescription = {
  options: {
    data: {},
    customization: {},
    widgets: {
      Menu_DescriptionTitleSettings: {
        type: 'Menu',
        order: 100,
        renderOptions: {
          controlKey: 'descriptionTitleSettings',
        },
        options: {
          text: {
            type: 'Text',
            order: 1,
          },
          isShowDescriptionTitle: {
            type: 'Radio',
            order: 14,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          descriptionTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 15,
          },
          descriptionTitleTextColor: {
            type: 'HexColor',
            order: 16,
          },
          descriptionTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 17,
          },
          descriptionTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 19,
          },
          descriptionTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 20,
          },
        },
      },
      Menu_ProductTitleSettings: {
        type: 'Menu',
        order: 200,
        renderOptions: {
          controlKey: 'productTitleSettings',
        },
        options: {
          productNameText: {
            type: 'Text',
            order: 1,
          },
          isShowProductTitle: {
            type: 'Radio',
            order: 14,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
          productTitleTextSize: {
            type: 'RangePx',
            data: {
              max: 30,
              min: 0,
              step: 1,
            },
            order: 15,
          },
          productTitleTextColor: {
            type: 'HexColor',
            order: 16,
          },
          ProductTitleTextAlignment: {
            type: 'LeftCenterRight',
            order: 17,
          },
          ProductTitleTextStyle: {
            type: 'SelectBox',
            data: {
              selectOptions: ['normal', 'italic'],
            },
            order: 19,
          },
          ProductTitleTextWeight: {
            type: 'SelectBox',
            data: {
              selectOptions: ['100', '200', '300', '400', '500', '600', '700', '800', '900'],
            },
            order: 20,
          },
          isOpenDescriptionAccordion: {
            type: 'Radio',
            order: 21,
            data: {
              direction: 'row',
              radioOptions: ['show', 'notShow'],
            },
          },
        },
      },
    },
  },
  variants: [
    {
      id: 'Description_1',
      name: 'Description_1',
      type: 'ProductDetailDescription',
      data: {
        text: '',
      },
      customization: {
        descriptionTitleTextSize: '13px',
        descriptionTitleTextColor: '#000000',
        descriptionTitleTextStyle: 'normal',
        descriptionTitleTextWeight: '400',
        isShowDescriptionTitle: 'notShow',
        descriptionTitleTextAlignment: 'left',
        isShowProductTitle: 'show',
        productTitleTextSize: '16px',
        productTitleTextColor: '#000000',
        productTitleTextStyle: 'normal',
        productTitleTextWeight: '500',
        productTitleTextAlignment: 'left',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Description_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Description_2',
      name: 'Description_2',
      type: 'ProductDetailDescription',
      data: {
        text: '',
      },
      customization: {
        descriptionTitleTextSize: '13px',
        descriptionTitleTextColor: '#000000',
        descriptionTitleTextStyle: 'normal',
        descriptionTitleTextWeight: '400',
        isShowDescriptionTitle: 'notShow',
        descriptionTitleTextAlignment: 'left',
        isShowProductTitle: 'show',
        productTitleTextSize: '16px',
        productTitleTextColor: '#000000',
        productTitleTextStyle: 'normal',
        productTitleTextWeight: '500',
        productTitleTextAlignment: 'left',
        isOpenDescriptionAccordion: 'show',
        productNameText: 'Ürün Açıklama',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Description_1.png',
      minMobileAppVersion: 1,
      isComingSoon: false,
    },
    {
      id: 'Description_3',
      name: 'Description_3',
      type: 'ProductDetailDescription',
      data: {
        text: '',
      },
      customization: {
        descriptionTitleTextSize: '13px',
        descriptionTitleTextColor: '#000000',
        descriptionTitleTextStyle: 'normal',
        descriptionTitleTextWeight: '400',
        isShowDescriptionTitle: 'notShow',
        descriptionTitleTextAlignment: 'left',
        isShowProductTitle: 'show',
        productTitleTextSize: '16px',
        productTitleTextColor: '#000000',
        productTitleTextStyle: 'normal',
        productTitleTextWeight: '500',
        productTitleTextAlignment: 'left',
      },
      variantData: {
        isEditable: false,
        aspectRatio: '1/1',
        minImage: 4,
        maxImage: 12,
        modulo: 1,
        renderTabs: {
          product: null,
        },
      },
      placeholderImage: 'https://d9aff4nz0lkg0.cloudfront.net/Description_1.png',
      minMobileAppVersion: 1,
      isComingSoon: true,
    },
  ],
};

export default ProductDetailDescription;
